const prefix = window.location.origin;
const IMG_SERVER_PATH_SAMPLE = prefix + '/TrendyScm-rest/rest/common/pic/show';
const noImg = '';
import { getCookie } from 'src/store/utils';

export function parseImgUrlToken(url) {

    if(url) {
        if(url.includes('logic') || url.includes('img3') || url.includes('trendy-scm.oss-cn-shenzhen.aliyuncs.com')) {
            return url
        } else {
            url = url.split('&')[0]
            return `${url}&display=true&token=${getCookie('AdminUserToken')}`
        }
    } else {
        return noImg
    }
}
 
export function formatImgUrl(url) {
    if (url) {
        if (/http/.test(url)) {
            return url
        }
        else if (/base64/.test(url)) {
            return url
        }
        else {
            return `${IMG_SERVER_PATH_SAMPLE}/${url}`;
        }
    } else {
        return noImg;
    }
}

export function parseImgUrl(obj) {
    try {
        const urlKey = JSON.parse(obj);
        if (urlKey.productImg) {
            return formatImgUrl(urlKey.productImg)
        }
        else {
            return formatImgUrl(urlKey.sampleImg)
        }
    }
    catch (e) {
        // console.log(e)
        return formatImgUrl(obj)
    }
}

export function parseImgUrlProductImg(obj) {
    try {
        const urlKey = JSON.parse(obj);
        if (urlKey.productImg) {
            return formatImgUrl(urlKey.productImg)
        }
        else {
            return formatImgUrl(urlKey.sampleImg)
        }
    }
    catch (e) {
        // console.log(e)
        return formatImgUrl(obj)
    }
}

export function parseImgUrlSampleImg(obj) {
    try {
        const urlKey = JSON.parse(obj);
        if (urlKey.sampleImg) {
            return formatImgUrl(urlKey.sampleImg)
        }
        else {
            return formatImgUrl(urlKey.productImg)
        }
    }
    catch (e) {
        // console.log(e)
        return formatImgUrl(obj)
    }
}

export function setImgStyle(url, needFormat = false, formatUrl = parseImgUrlToken,) {
    const img = new Image();
    let isWidth;
    const className = 'img-' + (parseInt(Math.random() * 100000)) + '' + new Date().getTime();
    img.onload = function () {
        console.log('img.onload')
        isWidth = img.width > img.height ? true : false;
        setEleImg(isWidth);

    }
    img.src = needFormat ? formatUrl(url) : url;
    if (img.complete) {
        console.log('img.complete')
        isWidth = img.width > img.height ? true : false;
        setEleImg(isWidth);
    }
    return {
        class: className,
        url: img.src
    }
    function setEleImg(flag) {
        const el = document.querySelector(`.${className}`);
        if (el) {
            el.style = flag ? 'width: 100%;height: auto' : 'width: auto;height: 100%';
        }
    }
}